import { concat, find, size, some } from 'es-toolkit/compat';
import { Procedure } from 'interfaces/procedure';

import { assignManifestDraftCaseIds, ManifestCaseTarget, ManifestDialogUrlState } from './dialogState';
import { removeSlidesFromManifestCases } from './manifestResolution';

export const caseNameFromFileName = (fileName?: string | null, fallback = 'Unnamed file') => {
  const withoutExtension = (fileName || '').replace(/\.[^./\\]+$/, '');
  const stripped = withoutExtension.replace(/\.ome$/i, '').trim();
  return stripped || fallback;
};

export const updateManifestCaseTarget = ({
  previousState,
  currentDraftCases,
  slideId,
  previousTarget,
  target,
}: {
  previousState: ManifestDialogUrlState;
  currentDraftCases: Procedure[];
  slideId: string;
  previousTarget: ManifestCaseTarget;
  target: ManifestCaseTarget;
}): ManifestDialogUrlState => {
  const nextState = {
    ...previousState,
    existingCaseAssignmentsBySlideId: {
      ...previousState.existingCaseAssignmentsBySlideId,
      [slideId]: target,
    },
  };
  if (target !== 'new') return nextState;
  const displayedCase = find(currentDraftCases, (procedure) => some(procedure.slides, { id: slideId }));
  const slide = find(displayedCase?.slides, { id: slideId });
  if (!displayedCase || !slide) return nextState;
  if (previousTarget === 'new' && size(displayedCase.slides) === 1) return nextState;
  const [detachedCase] = assignManifestDraftCaseIds({
    cases: [{ ...displayedCase, label: '', slides: [slide] }],
    retainedCases: concat(
      previousState.uploadedManifestCases || [],
      previousState.manualManifestCases || [],
      currentDraftCases
    ),
    casePatchesById: previousState.casePatchesById,
  });
  return {
    ...nextState,
    uploadedManifestCases: removeSlidesFromManifestCases(previousState.uploadedManifestCases || [], [slideId]),
    manualManifestCases: concat(
      removeSlidesFromManifestCases(previousState.manualManifestCases || [], [slideId]),
      detachedCase
    ),
  };
};
